export const networking = {
  'QrBadge': 'QR Badge',
  'seeAll': 'Просмотреть всех',
  'newcommers': 'New Networkers',
  'checkThemOut': 'Посмотреть новичков!',
  'topicsToDiscuss': 'Обсуждения тем',
  'OneOnOneMeet': 'Встречи 1:1',
  'learnMoreNetworking': 'Узнать больше о Networking Hub',
  'scanQrCode': 'Сканировать QR-код',
  'myBadge': 'My badge',
  'message': 'Сообщение',
  'scannedBadge': 'Scanned badge',
  'viewProfile': 'Профиль',
  'userRatingDetails': 'Детали рейтинга пользователя',
  'networkingHub': 'Networking Hub',
  'totalScore': 'Общее количество баллов:',
  'scoreComposedOf': 'Количество баллов рассчитывается из следующих активностей:',
  'confirmationText': 'Вы уверены? Это действие невозможно отменить.',
  'discussionTopic': 'Заинтересованность в обсуждении',
  'notes': 'Заметки',

  'welcomeMessage': 'Добро пожаловать в <strong>Networking Hub</strong> — место, где рождаются новые связи! Вот как это работает:',
  'connectingMadeSimpleTitle': 'Основная активность',
  'connectingMadeSimpleDescription':
    'Networking Hub предлагает различные активности и уровни, чтобы помочь вам эффективно заводить новые знакомства:',

  'newcomersDescription':
    '<strong>New Networkers:</strong> Просматривайте профили новичков, добавляйте интересных в список и отправляйте сообщения.',
  'shortlistDescription': '<strong>Shortlist:</strong> Когда вы проявляете интерес к кому-то, он добавляется в ваш список.',
  'contactedConnectedDescription':
    '<strong>Contacted/Connected:</strong> Когда вы связываетесь с кем-то и получаете ответ, он переходит в эти категории.',
  'skipDescription': '<strong>Skip:</strong> Не заинтересованы? Просто пропустите профиль и двигайтесь дальше!',

  'enhancedNetworkingActivitiesTitle': 'Улучшенные нетворкинг активности',
  'enhancedNetworkingActivitiesDescription': 'Помимо прямых знакомств, Hub включает:',

  'topicsToDiscussDescription':
    '<strong>Темы для обсуждений:</strong> Находите интересующие вас темы, знакомьтесь с авторами или участниками. Участвуйте в онлайн-дискуссиях или планируйте групповые встречи для более глубокого изучения этих тем.',
  'oneOnOneMeetingPlannerDescription':
    '<strong>Встречи 1:1:</strong> Управляйте запросами на встречи, отслеживайте запланированные встречи и легко организовывайте свой график.',

  'gamificationTitle': 'Геймификация для развлечения и вовлеченности',
  'gamificationDescription':
    'Повышайте свою активность с помощью таблицы лидеров, где отображаются ваши баллы и самые активные участники. Вот как можно зарабатывать баллы:',

  'pointsSystem': {
    points1000ProfileComplete: '<strong>1,000 баллов:</strong> Заполнили свой профиль (включая фото). ',
    points1000PushNotifications: '<strong>1,000 баллов:</strong> Включили push-уведомления.',
    points100SendMeetingRequest: '<strong>100 баллов:</strong> Отправили запрос на встречу 1:1.',
    points400GetAcceptedRequest: '<strong>400 баллов:</strong> Получили подтверждение вашего запроса на встречу 1:1.',
    points400AcceptRequest: '<strong>400 баллов:</strong> Приняли запрос на встречу 1:1.',
    points100DeclineRequest: '<strong>100 баллов:</strong> Отклонили запрос на встречу 1:1.',
    points400CreateDiscussion: '<strong>400 баллов:</strong> Создали тему для обсуждения.',
    points50LikeDiscussion: '<strong>50 баллов:</strong> Поставили лайк теме для обсуждения.',
    points200PostFirstComment: '<strong>200 баллов:</strong> Оставили первый комментарий на другой теме.',
    points100LikeOnTopic: '<strong>100 баллов:</strong> Получили лайк на свою тему.',
    points200UniqueCommenter: '<strong>200 баллов:</strong> Получили уникального комментатора на своей теме.',
    points100LikeShortlistUser: '<strong>100 баллов:</strong> Лайкнули/добавили пользователя в список.',
    points50SkipUser: '<strong>50 баллов:</strong> Пропустили пользователя.',
    points200StartChat: '<strong>200 баллов:</strong> Начали чат.',
    points300GetChatResponse: '<strong>300 баллов:</strong> Получили ответ в чате.',
    points400RespondToChat: '<strong>400 баллов:</strong> Ответили на запрос в чате.',
    points500SpeedNetworking: '<strong>500 баллов:</strong> За каждую сессию быстрого нетворкинга.'
  },

  'finalMessage': 'Используйте Networking Hub по максимуму, открывайте новые возможности и поднимайтесь в рейтинге!',

  'manageMeeting': 'Управлять встречей',
  'addToCalendar': 'Добавить в календарь',
  'cancel': 'Отменить',
  'accept': 'Принять',
  'accept&addToCalendar': 'Принять и добавить в календарь',
  'editDetails': 'Редактировать детали',
  'reject': 'Отклонить',
  'delete': 'Удалить',
  'exportContact': 'Экспортировать контакт',
  'scheduleNewOneOnOne': 'Запланировать новую встречу 1:1',
  'initiatedBy': 'Инициировано',
  'rejectedBy': 'Отклонено',
  'you': 'вами',
  'meetPassed': 'Встреча уже прошла',
  'meetInProgress': 'В процессе',

  'myOneOnOne': 'Мои 1:1',

  'speed': {
    history: 'История',
    minutes: 'мин.',
    users_available: 'доступно',
    rules: 'Правила',
    activate: 'Активировать',
    matching: 'Поиск...',
    start: 'Начать',
    find_a_user: 'Найди пользователя с таким же изображением',
    find_a_user_number: 'Найди пользователя с таким же номером',
    waiting: 'Ожидание...',
    speaking_now: 'Говорит сейчас',
    networking_topics: 'Темы для общения',
    session_ended: 'Сессия завершена',
    find_next_partner: 'Найти следующего партнера',
    find_next_group: 'Найти следующую группу',
    partner_wasnt_ready: 'Партнёр не был готов',
    partner_wasnt_ready_description: 'Похоже, партнёр не был готов к беседе. Давайте найдём нового!',
    start_matching: 'Начать поиск'
  }
}
